// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"129d34aa","54":"27327006","666":"f9c8404a","788":"88c34716","858":"47d3342a"}[chunkId] + ".chunk.js";
};